export enum TimeReportingType {
  TIMER = 'timer',
  MANUAL = 'manual',
  RANGE = 'range'
}
